let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fOQw")).then(() => parcelRequire('ao3s0'));